import LoginApp from '../../vue/apps/login';

(() => {
	'use strict';

	$(document).ready(() => {    
		const loginAppEl = document.getElementById('loginApp');

		if(loginAppEl){
			new LoginApp(loginAppEl);
        }
	});
})();
